export default __webpack_public_path__ + "static/media/totalbvstotalifa_graph.c60dec35.svg";